// eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides
import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, AnchorHTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerFooterPoweredByLink: ComponentType<
	ClassAttributes<HTMLAnchorElement> & AnchorHTMLAttributes<HTMLAnchorElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.a({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	font: token('font.body.small'),
	color: token('color.text.subtlest'),
	flexWrap: 'wrap',
	'&:hover': {
		textDecoration: 'underline',
		color: token('color.text.subtlest'),
	},
});
